export type DowntimeLabel = 'Paid' | 'Unpaid';

/** Shift.gapUnpaid uses 1 for unpaid downtime and 0/null for paid downtime. */
export const formatDowntimeLabel = (gapUnpaid: unknown): DowntimeLabel => (
    Number(gapUnpaid) === 1 ? 'Unpaid' : 'Paid'
);
